import { useQuery } from 'react-query';

import { getCardsHeaderView as queryFn } from 'api/endPoints/getCardsHeaderView';

export const useQueryCountersData = (params) => {
    return useQuery<ICountersDataResponse, QueryError>(['CountersData', params], () => queryFn(params), {
        enabled: Boolean(params) && params?.filter.filters.length > 0,
    });
};

export interface ICountersDataResponse {
    kcInsightCompletedCount: number;
    kcInsightInProgressCount: number;
    kcInsightTodoCount: number;
    milestoneCompletedCount: number;
    milestoneInProgressCount: number;
    milestoneTodoCount: number;
    tdaCompletedCount: number;
    tdaInProgressCount: number;
    tdaTodoCount: number;
    userGeneratedCompletedCount: number;
    userGeneratedInProgressCount: number;
    userGeneratedTodoCount: number;
    wbsCompletedCount: number;
    wbsInProgressCount: number;
    wbsTodoCount: number;
    loeCompletedCount: number;
    loeInProgressCount: number;
    loeTodoCount: number;
}
